<template>
  <div
    :class="{'input-file': true, 'has-file': showDownload}">
    <div
      class="file-input-wrapper"
      v-if="!showDownload">
      <v-file-input
        @change="onChangeFile"
        :label="renderLabel"
        :loading="isUploading"
        :error-messages="errorText"
        :outlined="outlined"
        :dense="dense"
        ref="input"
        prepend-icon=""
        :clearable="false"
        :disabled="readonly"
      />
      <v-icon>
        mdi-paperclip
      </v-icon>
    </div>
    <div
      v-else
      class="existing-files-controls">
      <v-text-field
        :label="renderLabel"
        readonly
        :outlined="outlined"
        :dense="dense"
        :value="' '" />
      <div
        class="controls">
        <v-btn
          depressed
          v-if="canDownload"
          color="primary"
          @click="downloadFile">
          Download
        </v-btn>
        <v-btn
          v-if="canDeleteFile"
          depressed
          @click="deleteFile">
          Löschen
        </v-btn>
      </div>
      <v-icon>
        mdi-paperclip
      </v-icon>
    </div>
  </div>
</template>

<script>
import InputMixin from './mixins/InputMixin'
import Api from '@/api/api.js'
export default {
  name: '',

  mixins: [
    InputMixin
  ],

  data () {
    return {
      isUploading: false,
      errorText: ''
    }
  },

  computed: {
    showDownload () {
      if (this.value === 'file' && (this.canDownload || this.canDeleteFile)) {
        return true
      }
      return false
    },

    canDownload () {
      return this.$store.getters['hasPermissionToGetFile']
    },

    canDeleteFile () {
      return !this.readonly && this.$store.getters['hasPermissionToDeleteFile']
    }
  },

  methods: {
    downloadFile () {
      const candidateUUID = this.$store.getters['getCandidateUUID']
      const questionKey = this.question.key
      Api.getFile(candidateUUID, questionKey)
    },
    deleteFile () {
      const candidateUUID = this.$store.getters['getCandidateUUID']
      const questionKey = this.question.key
      Api
        .deleteFile(candidateUUID, questionKey)
        .then(() => {
          this.val = undefined
        })
    },
    onChangeFile (file) {
      if (!file) {
        return
      }
      this.isUploading = true
      this.errorText = ''
      const candidateUUID = this.$store.getters['getCandidateUUID']
      const questionKey = this.question.key
      this.$store.commit('addRunningUpload')
      Api
        .uploadFile(file, candidateUUID, questionKey)
        .then(() => {
          this.isUploading = false
          this.$refs.input.blur()
          this.val = 'file'
          this.$store.commit('removeRunningUpload')
        })
        .catch((err) => {
          let errorText
          try {
            errorText = err.response.data.error
          } catch (e) {
            errorText = 'Datei konnte nicht hochgeladen werden.'
          }
          this.isUploading = false
          this.errorText = errorText
          this.val = void 0
          this.$store.commit('removeRunningUpload')
        })
    }
  }
}
</script>

<style lang="scss">
  .input-file {
    .file-input-wrapper,
    .existing-files-controls {
      position: relative;

      .v-icon {
        position: absolute;
        right: 0.5em;
        top: 0;
        transform: translateY(.70em);
      }
    }

    .existing-files-controls {
      position: relative;

      .v-text-field {
        pointer-events: none;
      }

      .controls {
        position: absolute;
        top: 0.85em;
        left: 1em;
        display: flex;
        align-items: center;
        justify-content: center;

        > * {
          &:not(:last-child) {
            margin-right: 1em;
          }
        }
      }
    }
  }
</style>
